import { unref, onMounted, onUnmounted } from 'vue'
import configResolver from '@/common/helpers/configResolver'
import HttpService from '@/common/services/HttpService'
import { getCaseWorklog } from '@/common/services/CaseService'
import { useCaseWorklogStore } from '@/agent/stores/caseWorklogStore'
import { useCaseStore } from '@/agent/stores/caseStore'

export async function initCaseWorklog(caseId: number) {
  const { data: worklog } = await getCaseWorklog(caseId)
  useCaseWorklogStore().init(worklog)
  useCaseStore().caseLockedUser = worklog.caseLockedUser ?? undefined
}

export function useWorklog() {
  const caseWorklogStore = useCaseWorklogStore()

  /**
   * Manage ticket worklog update
   * */
  const update = (beacon: boolean = true) => {
    if (!caseWorklogStore.initialized) return
    const worklogId = unref(caseWorklogStore.id)
    if (configResolver.pathname && worklogId) {
      const beaconData = {
        worklogId,
      }
      if (beacon) navigator.sendBeacon(`${configResolver.pathname}rest/tickets/saveTicketWorklogThymeleaf`, JSON.stringify(beaconData))
      else return HttpService.post(`rest/tickets/saveTicketWorklogThymeleaf`, beaconData)
    }
  }

  const updateWorklogEventListener = () => {
    update()
    caseWorklogStore.$reset()
  }

  const close = async () => {
    try {
      await update(false)
    } catch (error) {
      console.log(error)
    } finally {
      caseWorklogStore.$reset()
    }
  }

  onMounted(() => {
    window.addEventListener('pagehide', handlePageHide)
  })

  onUnmounted(() => {
    window.removeEventListener('pagehide', handlePageHide)
  })

  function handlePageHide(event: PageTransitionEvent) {
    if (event.persisted) return
    updateWorklogEventListener()
  }

  return {
    close,
  }
}
